export default __webpack_public_path__ + "static/media/Knee.e56d0f12.png";